export default {
    badge: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/badge/state.js